import _ from "lodash";

export type ValidationFunctionType = (v: string) => true | string;

const VRequired = [
  (v: string): true | string =>
    (v != null && _.trim(v) && !!v) || "This field is required",
];

const VEmail = [
  (v: string): true | string =>
    !v ||
    /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
    "Email must be valid",
];

export default {
  VRequired,
  VEmail,
};
